import '../styles/home.css'
import png2 from "../images/611390a51470d4b076c7ac593c0dae74507f3122a7801-Yn0cgN 1.png" 
import png1 from "../images/611390a51470d4b076c7ac593c0dae74507f3122a7801-Yn0cgN 2.png"
const Home = () => {
  return (
    <div className="home-page">
       <main className="content-area">
        
       
        <h1 className="section-title">The AI Guardian Platform</h1>
        <p className="section-subtitle">
            Providing a unified framework for safeguarding Large Language Models (LLMs). We empower organizations to deploy AI responsibly by providing robust, predictable, explainable security, and actionable insights to protect models, organizations, and end-users.
        </p>

       
        <div className="card-grid-2" style={{marginBottom: "80px"}}>
            <div className="card">
                <h2 style={{color: "#4f46e5"}}>Theory Grounded</h2>
                <p>To ensure safe and trustworthy AI adoption for developers, we integrate Safeguarding Framework that protects LLMs from manipulation, misuse, and ensures compliance with ethical and regulatory standards.</p>
                <ul className="feature-list">
                    <li><span className="feature-icon">&#x2713;</span> Flexible Solution</li>
                    <li><span className="feature-icon">&#x2713;</span> Setup in seconds</li>
                </ul>
            </div>
            
            
            
            <div className="card">
                <h2 style={{color: "#4f46e5"}}>Core Values</h2>
                <ul className="feature-list">
                    <li><span className="feature-icon">&#x2713;</span> Trustworthiness: Building confidence in AI systems through transparency and accountability.</li>
                    <li><span className="feature-icon">&#x2713;</span> Innovation with Responsibility: Advancing AI while embedding ethical safety levers.</li>
                    <li><span className="feature-icon">&#x2713;</span> Collaboration: Partnering with researchers, enterprises, and regulators to shape the future of AI.</li>
                    <li><span className="feature-icon">&#x2713;</span> Resilience: Ensuring systems adopt and withstand evolving AI threats.</li>
                </ul>
            </div>
        </div>

        
        <h1 className="section-title">Our Products</h1>
        <p className="section-subtitle" style={{marginBottom: "24px"}}>&nbsp;</p>

    
        <div className="products-container">
       
            <div className="product-card">
                <div className="product-icon-wrapper">
                   
                    <img
                          className="thumbnail_9"
                          referrerPolicy="no-referrer"
                          src={png1}
                        />
                </div>
                <div className="product-content">
                    <h2>Probe</h2>
                    <h3 style={{color: "var(--text-dark)"}}>AI Red Teaming and Risk Assessment</h3>
                    <p>Probe identifies **algorithmic vulnerabilities** before they reach production with **advanced red teaming** to proactively prevent and detect adversarial attacks.</p>
                </div>
            </div>

       
            <div className="product-card">
                <div className="product-icon-wrapper">
                   
                    
                    <img
                          className="thumbnail_9"
                          referrerPolicy="no-referrer"
                          src={png2}
                        />
                </div>
                <div className="product-content">
                    <h2>Shield</h2>
                    <h3 style={{color: "var(--text-dark)"}}>Real-Time AI Guardrails</h3>
                    <p>Shield provides **real-time AI guardrails** that automatically detect malicious queries and responses **on-the-fly** as your system operates.</p>
                </div>
            </div>
        </div>

       
        <h1 className="section-title" style={{marginTop: "40px"}}>Key Advantages of Probe</h1>
        <p className="section-subtitle" style={{marginBottom: "40px"}}>
            Accelerate red teaming for exposing critical vulnerabilities across all models across diverse attack scenarios with comprehensive coverage of offensive language, evasion techniques, and illegal activities.
        </p>

 
        <div className="card-grid">
            <div className="advantage-item">
                <div className="advantage-icon black-box-icon"></div>
                <h3>Black-Box Testing</h3>
                <p>No access to internal model states required—test any LLM through API interactions.</p>
            </div>
            <div className="advantage-item">
                <div className="advantage-icon coverage-icon"></div>
                <h3>Wide Attack Coverage</h3>
                <p>Comprehensive testing across diverse attack scenarios with a quantitative risk assessment report.</p>
            </div>
            <div className="advantage-item">
                <div className="advantage-icon deployment-icon"></div>
                <h3>Flexible Deployment</h3>
                <p>Cloud-based, on-premise, or local deployment options to suit your security requirements.</p>
            </div>
        </div>
        
       
        <h1 className="section-title" style={{marginTop: "40px"}}>Key Advantages of Shield</h1>
        <p className="section-subtitle" style={{marginBottom: "40px"}}>
            Shield delivers non-finetuning-based prompt-level defences that integrate with any off-the-shelf LLM without modifying internal parameters.
        </p>

        <div className="card-grid">
            <div className="advantage-item">
                <div className="advantage-icon non-finetuning-icon"></div>
                <h3>Non-finetuning-based defence</h3>
                <p>Protection that works with any off-the-shelf LLM without knowing internal parameters.</p>
            </div>
            <div className="advantage-item">
                <div className="advantage-icon realtime-icon"></div>
                <h3>Real-time protection</h3>
                <p>Operational blocking during live applications with low-latency performance.</p>
            </div>
            <div className="advantage-item">
                <div className="advantage-icon flexible-deploy-icon"></div>
                <h3>Flexible Deployment</h3>
                <p>Cloud-based, on-premise, or local deployment options to suit your security requirements.</p>
            </div>
        </div>
    
        
        
        <h1 className="section-title" style={{marginTop: "40px"}}>Achieving responsible AI deployment with AI Guardian!</h1>
         <p className="section-subtitle">©aiguardian All Rights Reserved.</p>
    </main>
    </div> 
)
}
export default Home;